import { render, staticRenderFns } from "./AffiliateSyncStatus.vue?vue&type=template&id=32232426&scoped=true"
import script from "./AffiliateSyncStatus.vue?vue&type=script&lang=js"
export * from "./AffiliateSyncStatus.vue?vue&type=script&lang=js"
import style0 from "./AffiliateSyncStatus.vue?vue&type=style&index=0&id=32232426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32232426",
  null
  
)

export default component.exports